<template>
	<div>
		<vs-table>
			<template #thead>
				<vs-tr>
					<vs-th style="width: 250px">
						<editar v-model="activeEditar" :info="selectedInfo" @refreshTable="refreshTable"></editar>
						<eliminar v-model="activeEliminar" :info="selectedInfo" @refreshTable="refreshTable"></eliminar>
						Nombre
					</vs-th>
					<vs-th style="width: 120px">
						Tipo
					</vs-th>
					<vs-th>
						Descripción
					</vs-th>
					<vs-th v-if="JSON.parse(personaRol).roles[0].id == 1" style="width: 150px">
						Acciones
					</vs-th>
				</vs-tr>
			</template>
			<template #tbody>
				<vs-tr
				:key="i"
				v-for="(tr, i) in users"
				:data="tr"
				>
					<vs-td>
						{{ tr.nombre }}
					</vs-td>
					<vs-td>
						<md-chip v-if="tr.tipo_escala === 'numerica'" class="mb-1 fontMedium mini-chip col-blue"><strong>Númerica</strong></md-chip>
						<md-chip v-if="tr.tipo_escala === 'alfanumerica'" class="mb-1 fontMedium mini-chip col-purple"><strong>Alfanúmerica</strong></md-chip>
					</vs-td>
					<vs-td>
						{{ tr.descripcion }}
					</vs-td>
					<vs-td v-if="JSON.parse(personaRol).roles[0].id == 1">
						<div class="d-flex">
							<vs-button
							icon
							success
							@click="activeEditar = ! activeEditar; selectedInfo = tr;"
							v-if="(tr.editable) ? editable = true : false"
							>
							<i class="fas fa-edit" style="font-size:0.8rem"></i>
							</vs-button>
								<vs-button
								icon
								danger
								@click="activeEliminar = !activeEliminar; selectedInfo = tr;"
								v-if="(tr.permitir_eliminar) ? permitirEliminar = true : false"
								>
								<i class="fas fa-trash-alt" style="font-size:0.8rem"></i>
							</vs-button>
						</div>
					</vs-td>
				</vs-tr>
			</template>
			<template #notFound>
				No hay información
			</template>
		</vs-table>
	</div>
</template>

<script>
import editar from './modales/editar.vue'
import eliminar from './modales/eliminar.vue'
export default {
	props:[
	'users',
	'personaRol'
	],
	data(){
		return {
			activeEditar: false,
			editable: false,
			permitirEliminar: false,
			selectedInfo: [],
			activeEliminar: false
		}
	},
	methods:{
		refreshTable(){
			this.$emit('refreshTable')
		}
	},
	components:{
		editar,
		eliminar
	},
}
</script>

<style scoped>
.cien {
	width: 100px;
	background: none;
	display: inline-flex;
	justify-content: center;
	align-items: center;
}

.col-purple{
	color: purple;
	background: rgb(232, 218, 239);
}

.col-blue{
	color: #2874A6;
	background: rgb(214, 234, 248);
}
</style>